'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var loginForm = require('./loginForm.js');
var LoginEmailForm = require('./LoginEmailForm.js');
var OTPForm = require('./OTPForm.js');
require('./Login.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LoginContext = React.createContext({});
var useLoginContext = function () { return React.useContext(LoginContext); };
var Login = function (props) {
    var backIcon = props.backIcon, emailIcon = props.emailIcon, googleIcon = props.googleIcon, goToRegister = props.goToRegister, goToForgetPassword = props.goToForgetPassword, errorMessage = props.errorMessage, loginWithEmail = props.loginWithEmail, verificationOtp = props.verificationOtp, resendOtp = props.resendOtp, sendOtp = props.sendOtp, showPasswordIcon = props.showPasswordIcon, hidePasswordIcon = props.hidePasswordIcon, timeLeft = props.timeLeft, title = props.title, loginWithGoogle = props.loginWithGoogle, buttonNextId = props.buttonNextId, buttonResendId = props.buttonResendId, googleButtonLoading = props.googleButtonLoading, nextButtonLoading = props.nextButtonLoading, defaultPage = props.defaultPage, defaultPhoneNumber = props.phoneNumber, onPageChange = props.onPageChange, isModal = props.isModal;
    var _a = React.useState(defaultPage || 'login'), page = _a[0], setPage = _a[1];
    var _b = React.useState(defaultPhoneNumber || ''), phoneNumber = _b[0]; _b[1];
    var backToPrev = function (path) {
        setPage(path);
        if (onPageChange) {
            onPageChange(path);
        }
    };
    var LoginPage = function () {
        return (React__default['default'].createElement(LoginContext.Provider, { value: {
                showPasswordIcon: showPasswordIcon,
                hidePasswordIcon: hidePasswordIcon,
                backIcon: backIcon,
                emailIcon: emailIcon,
                googleIcon: googleIcon,
                backToPrev: backToPrev,
                phoneNumber: phoneNumber,
                goToRegister: goToRegister,
                goToForgetPassword: goToForgetPassword,
                loginWithEmail: loginWithEmail,
                verificationOtp: verificationOtp,
                resendOtp: resendOtp,
                sendOtp: sendOtp,
                errorMessage: errorMessage,
                timeLeft: timeLeft,
                title: title,
                loginWithGoogle: loginWithGoogle,
                buttonNextId: buttonNextId,
                buttonResendId: buttonResendId,
                googleButtonLoading: googleButtonLoading,
                nextButtonLoading: nextButtonLoading,
                page: page,
            } },
            React__default['default'].createElement("div", { className: 'login' },
                React__default['default'].createElement("div", { className: 'top' }),
                React__default['default'].createElement("div", { className: 'center' }, page === 'login-email' ?
                    React__default['default'].createElement(LoginEmailForm.LoginEmailForm, { previous: 'login', isModal: isModal })
                    : page === 'otp' ?
                        React__default['default'].createElement(OTPForm.OTPForm, { previous: 'login', isModal: isModal })
                        :
                            React__default['default'].createElement(loginForm.LoginForm, { isModal: isModal })),
                React__default['default'].createElement("div", { className: 'bottom' }))));
    };
    var LoginModal = function () {
        return (React__default['default'].createElement(LoginContext.Provider, { value: {
                showPasswordIcon: showPasswordIcon,
                hidePasswordIcon: hidePasswordIcon,
                backIcon: backIcon,
                emailIcon: emailIcon,
                googleIcon: googleIcon,
                backToPrev: backToPrev,
                phoneNumber: phoneNumber,
                goToRegister: goToRegister,
                goToForgetPassword: goToForgetPassword,
                loginWithEmail: loginWithEmail,
                verificationOtp: verificationOtp,
                resendOtp: resendOtp,
                sendOtp: sendOtp,
                errorMessage: errorMessage,
                timeLeft: timeLeft,
                title: title,
                loginWithGoogle: loginWithGoogle,
                buttonNextId: buttonNextId,
                buttonResendId: buttonResendId,
                googleButtonLoading: googleButtonLoading,
                nextButtonLoading: nextButtonLoading,
                page: page,
            } },
            React__default['default'].createElement("div", { className: 'login__modal' },
                React__default['default'].createElement("div", { className: 'center__modal' }, page === 'login-email' ?
                    React__default['default'].createElement(LoginEmailForm.LoginEmailForm, { previous: 'login', isModal: isModal })
                    : page === 'otp' ?
                        React__default['default'].createElement(OTPForm.OTPForm, { previous: 'login', isModal: isModal })
                        :
                            React__default['default'].createElement(loginForm.LoginForm, { isModal: isModal })))));
    };
    return isModal ? React__default['default'].createElement(LoginModal, null) : React__default['default'].createElement(LoginPage, null);
};

exports.Login = Login;
exports.useLoginContext = useLoginContext;
//# sourceMappingURL=index.js.map
